import { forwardRef, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer } from "react-toastify";
import loginStyle from './Login.module.css';
import TappetLogo from '../../assets/img/tappetbox.png';
import MobileLogo from '../../assets/img/tappet-mobile-logo.jpg';
import TapIcon from "../../services/TapIcon";
import whiteLogo from '../../assets/img/logo-white.png';
import TapHelper from "../../services/TapHelper";
import ValidationService from "../../services/ValidationService";
import { toast } from "react-toastify";
import HttpAPICall from "../../services/HttpAPICall";
import * as actions from '../../store/actions/index';


const Login2FA                 =   forwardRef((props, ref) => {


    const dispatch                  =   useDispatch();
    const history                   =   useHistory();
    const accessToken               =   useSelector(state => state.auth.access_token);

    const scrollRef                 =   useRef(null);

    let initFormData                =   {
        loading                         :   false,
        submitting                      :   false,
        userCanChange                   :   true,
        qrDataUrl                       :   "",
        secret                          :   "",
        group_id                        :   "",
        mobile                          :   "",
        code                            :   "",
        step                            :   "login"
    };

    const [showTopBtn, setShowTopBtn]           =   useState(false);
    const [formData, setFormData]               =   useState({...initFormData});

    let verifyUrl                   =   process.env.REACT_APP_SERVER_PATH + "/backoffice/2fa/verify";
    let generateUrl                 =   process.env.REACT_APP_SERVER_PATH + "/backoffice/2fa/generate";

    

    
    useEffect(() => {
        if (accessToken) {
            history.push('/dashboard');
        }
    }, [accessToken, history]);

    useEffect(() => {
        const div           =   scrollRef.current;
        const handleScroll = () => setShowTopBtn(div.scrollTop > 200)
        div.addEventListener('scroll', handleScroll);
        return () => div.removeEventListener('scroll', handleScroll);
 
    }, []);

    const scrollToTop           = () => scrollRef.current.scrollTo({ top: 0, behavior: "smooth" })


    const loginFormSubmitHandler    =   (event)  =>  {
        event.preventDefault();

        let data                    =   { ...TapHelper.pick(formData, ['group_id','mobile', 'code'])};

        let rules                   =   {
            group_id                    :   "required",
            mobile                      :   'required|numeric|min:10',
        };
        let rulesMsg                =   {
            mobile                      :    {required : 'Please enter valid phone'},
        };

        if(formData.step == "enroll") {
            rules                   =   {...rules, code : "required|numeric|min:6|digits:6"};
        }


        let error                   =   ValidationService.rulesFirstErrorGenerator(data, rules, rulesMsg);
        if(error) {
            toast.error(error);
        } else {
            if(formData.step == "enroll") {
                setFormData(d => ({...d, submitting : true}));
                HttpAPICall.withAthorization("POST", verifyUrl, null, {}, data, (resp) => {
                    dispatch(actions.authSuccess(resp.data), false);
                    dispatch(actions.applicationInitLoading(resp.data.access_token), false);
                }).catch((error) => {
                    toast.error(error.response?.data?.msg || "An error occurred", { position: toast.POSITION.TOP_RIGHT });
                }).finally(() => {
                    setFormData(pre => ({...pre, submitting : false}));
                });
            } else {
                setFormData(d => ({...d, submitting : true}));
                HttpAPICall.withAthorization("POST", generateUrl, null, {}, data, (resp) => {
                    setFormData(pre => ({...pre, userCanChange : false, qrDataUrl : resp.data.qrcode_svg, secret : resp.data.secret, step : "enroll"}));
                }).catch((error) => {
                    toast.error(error.response?.data?.msg || "An error occurred", { position: toast.POSITION.TOP_RIGHT });
                }).finally(() => {
                    setFormData(pre => ({...pre, submitting : false}));
                });
            }
       }
    }


    const loginFormJsx              =   ()  =>  {
        return <form className="p-3 pt-0" onSubmit={loginFormSubmitHandler}>
            <div className="mb-3 mt-3">
                <label className="form-label">Group ID</label>
                <div className="input-group">
                    <span className="input-group-text"><TapIcon.FontAwesomeIcon icon={TapIcon.faUsers}/></span>
                    <input
                        type="text"
                        value={formData.group_id}
                        placeholder="Enter Group/Company ID"
                        className="form-control"
                        readOnly={!formData.userCanChange}
                        tabIndex={1}
                        autoComplete="off"
                        required={true}
                        onChange={(e) => { setFormData(d => ({...d, group_id : e.target.value})); }}
                    />
                </div>
            </div>
            <div className="mb-3">
                <label className="form-label">User ID (Mobile No.)</label>
                <div className="input-group">
                    <span className="input-group-text"><TapIcon.FontAwesomeIcon icon={TapIcon.faUser}/></span>
                    <input
                        type="text"
                        value={formData.mobile}
                        placeholder="Enter Mobile Number"
                        className="form-control"
                        readOnly={!formData.userCanChange}
                        tabIndex={2}
                        autoComplete="off"
                        required={true}
                        onChange={(e) => { setFormData(d => ({...d, mobile : e.target.value})); }}
                    />
                </div>
            </div>

            {formData.step == "enroll" && <>
                <div className="text-center">
                    <img src={formData.qrDataUrl} alt="Scan this QR with Google Authenticator" />    
                </div>
                <div className="my-3">
                    <label className="form-label">Verification Code</label>
                    <div className="input-group">
                        <span className="input-group-text"><TapIcon.FontAwesomeIcon icon={TapIcon.faUnlock}/></span>
                        <input
                            type="text"
                            value={formData.code}
                            placeholder="Enter 6-digit Code"
                            className="form-control"
                            tabIndex={3}
                            autoComplete="off"
                            required={true}
                            maxLength={6}
                            minLength={6}
                            onChange={(e) => { setFormData(d => ({...d, code : e.target.value})); }}
                        />
                    </div>
                </div>
            </>}
            <div className="d-grid gap-2 mt-4 mb-2">
                <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    tabIndex={5}
                    disabled={formData.submitting}
                    > Submit
                    {formData.submitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ml5"/>}
                </button>
            </div>
        </form>
    }

    const topHeader             =   ()  =>  {
        return <nav className={loginStyle.nav_top}>
            <div className={['container'].join(' ')} >
                <div className="row">
                    <div className="col-md-7">
                        <a className={loginStyle.social_icon} target="_blank" href="https://www.facebook.com/tappetbox/?ref=aymt_homepage_panel">
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faFacebookF} />
                        </a>
                        <a className={loginStyle.social_icon} target="_blank" href="https://twitter.com/tappetbox">
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faTwitter} />
                        </a>
                        <a className={loginStyle.social_icon} target="_blank" href="https://www.linkedin.com/company/tappetbox">
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faLinkedinIn} />
                        </a>
                        <a className={loginStyle.social_icon} target="_blank" href="https://www.youtube.com/channel/UCq0x42wA3zUr_CPgHH8TaYg">
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faYoutube} />
                        </a>
                    </div>
                    <div className="col-md-5 text-end">Call Us Today! 9650-222-555</div>
                </div>
            </div>
        </nav>
    }

    const headerLogo            =   ()  =>  {
        return (<header className={loginStyle.header_wrapper}>
            <div className={['container'].join(' ')} >
                <div className="row">
                    <div className="col-md-12">
                        <img src={TappetLogo} height="60" alt="logo"/>
                    </div>
                </div>
            </div>
        </header>);
    }

    const footer                =   ()  =>  {
        return  <footer className={['container-fluid', 'mt-3', 'pb-3', 'text-white'].join(' ')}>
            <div className="row">
                <div className="col-md-4">
                    <img src={whiteLogo} className="mt-4" alt="Tappetbox" />
                    <div className={['mx-2', 'mt-2', 'text-sm'].join(' ')}></div>
                </div>
                <div className="col-md-4">
                    <p className={['mt-4' , 'text-xl'].join(' ')}>Contact Us</p>
                    <div className={['mx-2', 'mt-2', 'text-sm', 'text-secondary'].join(' ')}>
                        <p> LGF - 001H, Sushant Arcade,<br/> Sushant Lok-1, Gurugram, <br/> Haryana - 122001.<br /></p>
                        <p className="mt-3 mb-2">Phone: 9650-222-555<br/>Email: contact@tappetbox.com </p>
                    </div>
                </div>
                <div className="col-md-4">
                    <p className={['mt-4' , 'text-xl'].join(' ')}>Get Social</p>
                    <div className={['mx-2', 'mt-2', 'text-xl', 'text-secondary'].join(' ')}>
                        <a className="social_link text-secondary px-2" target="_blank" href="https://www.facebook.com/tappetbox/?ref=aymt_homepage_panel">
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faFacebookF} />
                        </a>
                        <a className="social_link text-secondary px-2" target="_blank" href="https://twitter.com/tappetbox">
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faTwitter} />
                        </a>
                        <a className="social_link text-secondary px-2" target="_blank" href="https://www.linkedin.com/company/tappetbox">
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faLinkedinIn} />
                        </a>
                        <a className="social_link text-secondary px-2" target="_blank" href="https://www.youtube.com/channel/UCq0x42wA3zUr_CPgHH8TaYg">
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faYoutube} />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    }
    
    const copywrite             =   ()  =>  {
        return (
            <>
                <div className="footer_copywrite text-center py-3 text-sm bg-dark text-white">Copyright © {new Date().getFullYear()}, Five Dots Solutions Pvt. Ltd. All Rights Reserved.</div>
                {showTopBtn && <div className="goto_top" onClick={scrollToTop}><span><TapIcon.FontAwesomeIcon icon={TapIcon.faAngleUp}/></span></div>}
            </>
        );
    }

    return <div className="pageTbl" style={{ height: "100vh" }} ref={scrollRef}>
        <ToastContainer />
        {topHeader()}
        {headerLogo()}
        <div className="container-fluid bg-white">
            <div className="row">
                <div className={['col-md-8', 'px-1'].join(' ')}><img src={MobileLogo} className={loginStyle.page_image} alt="Tappetbox"/></div>
                <div className={['col-md-4', 'p0' ,loginStyle.login_box].join(' ')}>
                    <h3 className="form-header mb-2">Login</h3>
                    {loginFormJsx()}
                    <div className={[loginStyle.tnc, 'text-xs', 'lh-base', 'p-3'].join(' ')}>By Logging, you agree to our <a target="_blank" href="https://tappetbox.in/software-license">Terms & Conditions </a> and that you have read our <a href="https://tappetbox.in/privacy-policy" target="_blank">Privacy Policy</a></div>
                </div>
            </div>
        </div>
        {footer()}
        {copywrite()}

     </div>

 });

export default Login2FA;